var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"anstract-detail-dialog"}},[_c('ipub-model',{staticClass:"copyright-documents",attrs:{"title":"Abstract","width":"1000px","visable":_vm.isVisable,"showFooter":false},on:{"cancel":_vm.cancel}},[_c('div',{staticClass:"ipub-p2"},[_vm._v("\n      "+_vm._s(_vm.abstract)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }